import { toastifyErrorMessage, toastifySuccess, Button } from "@ic-anywhere/ic-components";
import * as React from "react";
import { InvitationRequestStatus } from "src/api/invitationRequests/invitationRequest.typings";
import {
  useCreateInvitationRequestMutation,
  useDeleteInvitationRequestMutation,
} from "src/queries/invitationRequest.mutations";
import { useGetInvitationRequestQuery } from "src/queries/invitationRequest.queries";

type Props = {
  eventId: string;
};

export const InvitationRequestControl: React.FC<Props> = ({ eventId }) => {
  const { data: existingInvitationRequest } = useGetInvitationRequestQuery(eventId, !!eventId);

  const { mutate: createInvitationRequest } = useCreateInvitationRequestMutation(
    eventId,
    () => toastifySuccess("Registration request successfully sent to the event manager."),
    (message: string) => toastifyErrorMessage(message)
  );

  const { mutate: deleteInvitationRequest } = useDeleteInvitationRequestMutation(
    eventId,
    existingInvitationRequest?.id,
    () => toastifySuccess("Registration request cancelled."),
    (message: string) => toastifyErrorMessage(message)
  );

  return (
    <>
      {(existingInvitationRequest === undefined ||
        [InvitationRequestStatus.cancelled, InvitationRequestStatus.rejected].includes(
          existingInvitationRequest?.status
        )) && (
        <Button
          className="w-100 mt-2 py-12px"
          text="Request registration"
          onClick={(): void => createInvitationRequest()}
        />
      )}
      {existingInvitationRequest?.status === InvitationRequestStatus.pending && (
        <>
          <div className="d-flex justify-content-center alert alert-outline-info mt-2">
            <span>Registration pending approval</span>
          </div>
          <Button
            className="w-100 mt-2 py-12px"
            text="Cancel registration"
            color="danger"
            onClick={(): void => deleteInvitationRequest()}
          />
        </>
      )}
    </>
  );
};
